const isActive = (item, currentPage) => item.link === currentPage;

const hasActiveSubItem = (item, currentPage) => (item.subItems ? item.subItems.some((subItem) => subItem.link === currentPage) : false);


export const isActiveItem = (item, currentPage) => (isActive(item, currentPage) || hasActiveSubItem(item, currentPage));
